module.exports = __webpack_public_path__ + "img/HN300.png";